import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchBrands: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'brand/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_BRAND_REQUEST,
                        types.SEARCH_BRAND_SUCCESS,
                        types.SEARCH_BRAND_FAILURE
                    ]
                }
            });
        },

    saveBrand: (brand, file) => {
        let body = new FormData();
        body.append('logoFile', file);

        for (let [key, value] of Object.entries(brand)) {
            body.append(key, value);
        }

        return (dispatch) => {
            if (brand.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'brand/create',
                        method: 'POST',
                        body: body,
                        types: [
                            types.CREATE_BRAND_REQUEST,
                            types.CREATE_BRAND_SUCCESS,
                            types.CREATE_BRAND_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'brand/update',
                        method: 'PUT',
                        body: body,
                        types: [
                            types.UPDATE_BRAND_REQUEST,
                            types.UPDATE_BRAND_SUCCESS,
                            types.UPDATE_BRAND_FAILURE
                        ]
                    }
                });
            }
        }
    }

}
